var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _mask, _path22, _path23, _path24, _path25, _path26, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessVerifyId(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 313,
    viewBox: "0 0 313 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.397 88.3379C146.578 87.3334 148.343 83.9404 147.339 80.7592C146.334 77.5781 142.941 75.8136 139.76 76.818C136.579 77.8225 134.814 81.2155 135.819 84.3966C136.823 87.5778 140.216 89.3423 143.397 88.3379Z",
    fill: "#FF5073"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.338 80.7592C146.334 77.5782 142.941 75.8137 139.759 76.818C139.619 76.8625 139.482 76.913 139.347 76.9666C140.973 77.6148 142.305 78.9603 142.873 80.7594C143.834 83.8001 142.263 87.0325 139.344 88.1895C140.593 88.6875 142.015 88.7744 143.397 88.3381C146.578 87.3335 148.343 83.9403 147.338 80.7592Z",
    fill: "#EB3D60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0009 201.206C54.6287 197.93 52.4818 194.765 49.2056 194.137C45.9294 193.509 42.7646 195.656 42.1368 198.932C41.5089 202.208 43.6559 205.373 46.9321 206.001C50.2083 206.629 53.3731 204.482 54.0009 201.206Z",
    fill: "#FF5073"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2084 194.137C48.0338 193.912 46.8742 194.045 45.84 194.457C48.4821 195.506 50.0937 198.312 49.539 201.206C49.1362 203.308 47.6888 204.943 45.8384 205.681C46.187 205.819 46.5529 205.929 46.9347 206.002C50.211 206.63 53.3759 204.482 54.0038 201.206C54.6317 197.93 52.4848 194.765 49.2084 194.137Z",
    fill: "#EB3D60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.502 225L137.633 231.326L145.753 230.685L141.322 237.52L144.441 245.045L136.572 242.943L130.379 248.235L129.946 240.101L123 235.846L130.602 232.921L132.502 225Z",
    fill: "#FFB429"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.753 230.686L141.048 231.057L136.858 237.52L139.421 243.704L144.441 245.045L141.323 237.52L145.753 230.686Z",
    fill: "#F5A40C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.93 54L212.086 62.1015L218.28 67.3904L210.314 69.0904L207.199 76.6163L203.12 69.5655L195 68.9279L200.445 62.8704L198.542 54.9504L205.986 58.2573L212.93 54Z",
    fill: "#FFB429"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.931 57.0652L207.215 63.928L212.672 68.5871L218.28 67.3904L212.085 62.1015L212.93 54L207.931 57.0652Z",
    fill: "#F5A40C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.505 96.9328C270.044 93.9732 268.892 90.3262 265.933 88.787C262.973 87.2478 259.326 88.3993 257.787 91.3589C256.248 94.3185 257.399 97.9655 260.359 99.5047C263.318 101.044 266.965 99.8924 268.505 96.9328Z",
    fill: "#FF5073"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M265.932 88.7871C264.312 87.9451 262.488 87.91 260.915 88.5342C261.101 88.6087 261.285 88.6927 261.467 88.7871C264.427 90.3262 265.578 93.9733 264.039 96.9328C263.342 98.273 262.212 99.2411 260.91 99.7577C263.757 100.896 267.059 99.7109 268.504 96.9328C270.043 93.9731 268.891 90.3262 265.932 88.7871Z",
    fill: "#EB3D60"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M236.505 183.933C238.044 180.973 236.892 177.326 233.933 175.787C230.973 174.248 227.326 175.399 225.787 178.359C224.248 181.319 225.399 184.966 228.359 186.505C231.318 188.044 234.965 186.892 236.505 183.933Z",
    fill: "#FF5073"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M233.931 175.786C232.312 174.944 230.487 174.909 228.914 175.533C229.1 175.608 229.284 175.692 229.466 175.786C232.426 177.325 233.577 180.972 232.038 183.932C231.341 185.272 230.211 186.24 228.909 186.757C231.756 187.895 235.058 186.71 236.503 183.932C238.042 180.972 236.891 177.325 233.931 175.786Z",
    fill: "#EB3D60"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0987 170.775C77.6269 170.579 76.8268 170.43 76.1443 169.422C75.4615 168.414 75.6201 167.615 75.9848 166.175C76.3815 164.61 76.8749 162.661 75.3951 160.475C73.9153 158.289 71.9226 158.023 70.3215 157.81C68.8495 157.614 68.0495 157.465 67.3667 156.456C66.6839 155.448 66.8425 154.649 67.2071 153.209C67.6038 151.643 68.0973 149.695 66.6172 147.509C66.1459 146.813 65.1995 146.63 64.5036 147.102C63.8075 147.573 63.6252 148.519 64.0965 149.215C64.7793 150.224 64.6207 151.022 64.2561 152.462C63.8594 154.028 63.3659 155.977 64.846 158.163C66.3258 160.349 68.3184 160.614 69.9194 160.828C71.3915 161.024 72.1916 161.173 72.8744 162.182C73.5572 163.19 73.3986 163.988 73.0339 165.428C72.6374 166.994 72.1438 168.942 73.6238 171.128C75.1035 173.314 77.096 173.58 78.697 173.793C80.169 173.989 80.9688 174.138 81.6515 175.146C82.334 176.155 82.1753 176.953 81.8108 178.392C81.4141 179.958 80.9204 181.906 82.4001 184.092C82.7782 184.651 83.4621 184.878 84.0772 184.703C84.2288 184.66 84.3761 184.593 84.5137 184.499C85.2099 184.028 85.3921 183.082 84.9209 182.386C84.2383 181.377 84.397 180.579 84.7615 179.14C85.1583 177.574 85.652 175.626 84.1722 173.44C82.6924 171.254 80.6998 170.989 79.0987 170.775Z",
    fill: "#86DF75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9367 54.5C88.1189 55.4025 87.3053 55.4363 85.8205 55.425C84.2061 55.4112 82.1954 55.3939 80.4225 57.3495C78.6497 59.3055 78.8641 61.304 79.0364 62.9101C79.1946 64.3865 79.2393 65.1993 78.4214 66.1018C77.6036 67.0041 76.7886 67.0394 75.3055 67.0266C73.6892 67.013 71.6803 66.995 69.9076 68.9509C68.1349 70.9067 68.3496 72.9053 68.5219 74.5111C68.6804 75.9875 68.725 76.7999 67.9074 77.7022C67.0899 78.6043 66.2765 78.6394 64.792 78.6266C63.1764 78.6134 61.1668 78.5947 59.3943 80.5503C58.8298 81.1731 58.877 82.1359 59.5001 82.7005C59.7915 82.9645 60.1572 83.0946 60.5217 83.0946C60.9363 83.0946 61.3495 82.9262 61.65 82.5948C62.4677 81.6927 63.2799 81.6582 64.7654 81.6703C66.3808 81.6833 68.3906 81.7022 70.1631 79.7464C71.9358 77.7907 71.7211 75.7921 71.5488 74.1862C71.3903 72.7098 71.3456 71.8974 72.1633 70.9952C72.9809 70.0927 73.7927 70.0574 75.2793 70.0703C76.8929 70.0831 78.9044 70.1018 80.6773 68.146C82.4503 66.1903 82.2357 64.1915 82.0634 62.5854C81.9052 61.109 81.8605 60.2962 82.6784 59.3939C83.4964 58.4917 84.3104 58.4551 85.7945 58.4689C87.4096 58.4835 89.4199 58.5 91.1926 56.5444C91.7572 55.9216 91.7099 54.9588 91.0869 54.3944C90.4639 53.8296 89.5011 53.8771 88.9367 54.5Z",
    fill: "#86DF75"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M272.669 161.068C271.866 160.821 271.014 161.272 270.767 162.075C270.409 163.24 269.688 163.617 268.338 164.235C266.869 164.907 265.042 165.745 264.266 168.268C263.491 170.791 264.533 172.51 265.37 173.892C266.14 175.162 266.525 175.878 266.168 177.042C265.81 178.206 265.088 178.583 263.738 179.202C262.27 179.874 260.442 180.711 259.667 183.234C258.891 185.758 259.933 187.476 260.771 188.857C261.541 190.127 261.926 190.844 261.568 192.008C261.211 193.172 260.489 193.548 259.139 194.167C257.671 194.839 255.843 195.676 255.068 198.199C254.821 199.002 255.272 199.854 256.075 200.101C256.224 200.146 256.375 200.168 256.523 200.168C257.174 200.168 257.776 199.747 257.978 199.093C258.335 197.929 259.056 197.552 260.407 196.934C261.875 196.262 263.703 195.425 264.478 192.902C265.254 190.379 264.212 188.66 263.374 187.279C262.604 186.009 262.219 185.292 262.577 184.129C262.934 182.965 263.656 182.588 265.006 181.969C266.474 181.297 268.302 180.46 269.078 177.937C269.853 175.413 268.811 173.694 267.974 172.313C267.204 171.043 266.819 170.326 267.176 169.162C267.534 167.998 268.255 167.621 269.606 167.003C271.074 166.33 272.902 165.493 273.677 162.97C273.924 162.166 273.473 161.315 272.669 161.068Z",
    fill: "#86DF75"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.66 221.511C188.102 220.883 187.14 220.826 186.511 221.384C185.883 221.942 185.826 222.904 186.384 223.533L192.287 230.18C192.587 230.518 193.006 230.691 193.425 230.691C193.785 230.691 194.146 230.564 194.435 230.307C195.064 229.749 195.121 228.787 194.563 228.158L188.66 221.511Z",
    fill: "#1371EF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1449 226.013L85.3281 227.147C84.4944 227.254 83.9054 228.016 84.0126 228.85C84.1114 229.618 84.7661 230.179 85.5204 230.179C85.585 230.179 85.6505 230.174 85.7165 230.166L94.5333 229.032C95.367 228.925 95.956 228.162 95.8488 227.328C95.7415 226.495 94.9802 225.904 94.1449 226.013Z",
    fill: "#1371EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M243.821 226.052L236.346 221.242C235.639 220.788 234.697 220.992 234.242 221.699C233.787 222.405 233.992 223.347 234.699 223.802L242.174 228.612C242.429 228.776 242.714 228.854 242.996 228.854C243.497 228.854 243.987 228.608 244.278 228.156C244.733 227.449 244.528 226.507 243.821 226.052Z",
    fill: "#ABEEFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.66 46.5114C148.102 45.8827 147.14 45.8259 146.511 46.3842C145.883 46.9423 145.826 47.9042 146.384 48.5329L152.287 55.1797C152.587 55.5184 153.006 55.6911 153.425 55.6911C153.785 55.6911 154.146 55.5645 154.435 55.307C155.064 54.7489 155.121 53.7869 154.563 53.1582L148.66 46.5114Z",
    fill: "#ABEEFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3069 113.511C68.7488 112.883 67.7867 112.826 67.1582 113.384L60.5114 119.287C59.8829 119.845 59.8258 120.807 60.3839 121.436C60.6847 121.774 61.1028 121.947 61.5227 121.947C61.8821 121.947 62.2429 121.821 62.5327 121.563L69.1793 115.66C69.808 115.102 69.865 114.14 69.3069 113.511Z",
    fill: "#ABEEFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6601 86.5114C98.1021 85.8828 97.1399 85.8258 96.5114 86.3841C95.8829 86.9422 95.8258 87.9042 96.3839 88.5329L102.287 95.1796C102.587 95.5184 103.006 95.6911 103.425 95.6911C103.785 95.6911 104.146 95.5644 104.435 95.3069C105.064 94.7488 105.121 93.7869 104.563 93.1581L98.6601 86.5114Z",
    fill: "#1371EF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M216.187 107.241L212.939 98.9664C212.632 98.1841 211.749 97.7983 210.966 98.1058C210.184 98.413 209.798 99.2962 210.106 100.079L213.354 108.354C213.589 108.953 214.163 109.32 214.771 109.32C214.956 109.32 215.144 109.286 215.327 109.214C216.109 108.907 216.495 108.024 216.187 107.241Z",
    fill: "#1371EF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M250.333 127.095L241.995 130.177C241.206 130.469 240.803 131.344 241.095 132.132C241.322 132.747 241.904 133.127 242.523 133.127C242.698 133.127 242.876 133.097 243.05 133.032L251.388 129.95C252.177 129.658 252.58 128.783 252.288 127.994C251.996 127.206 251.121 126.804 250.333 127.095Z",
    fill: "#ABEEFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23833_17138)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23833_17138)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_23833_17138)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-24-outside-1_23833_17138",
    maskUnits: "userSpaceOnUse",
    x: 119.406,
    y: 117.906,
    width: 76,
    height: 76,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 119.406,
    y: 117.906,
    width: 76,
    height: 76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.5 192.094C177.434 192.094 193.594 175.934 193.594 156C193.594 136.066 177.434 119.906 157.5 119.906C137.566 119.906 121.406 136.066 121.406 156C121.406 175.934 137.566 192.094 157.5 192.094Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5 192.094C177.434 192.094 193.594 175.934 193.594 156C193.594 136.066 177.434 119.906 157.5 119.906C137.566 119.906 121.406 136.066 121.406 156C121.406 175.934 137.566 192.094 157.5 192.094Z",
    fill: "url(#paint0_radial_23833_17138)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_angular_23833_17138_clip_path)",
    "data-figma-skip-parse": "true",
    mask: "url(#path-24-outside-1_23833_17138)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.000984382 0.0771094 -0.244746 0.00312443 157.5 156)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -495.528,
    y: -495.528,
    width: 991.056,
    height: 991.056
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(81, 205, 109, 1) 0deg,rgba(104, 211, 128, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 0.6
    }
  })))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M193.594 156H191.953C191.953 175.028 176.528 190.453 157.5 190.453V192.094V193.734C178.34 193.734 195.234 176.84 195.234 156H193.594ZM157.5 192.094V190.453C138.472 190.453 123.047 175.028 123.047 156H121.406H119.766C119.766 176.84 136.66 193.734 157.5 193.734V192.094ZM121.406 156H123.047C123.047 136.972 138.472 121.547 157.5 121.547V119.906V118.266C136.66 118.266 119.766 135.16 119.766 156H121.406ZM157.5 119.906V121.547C176.528 121.547 191.953 136.972 191.953 156H193.594H195.234C195.234 135.16 178.34 118.266 157.5 118.266V119.906Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.31764706969261169,\"g\":0.80392158031463623,\"b\":0.42745098471641541,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.40784314274787903,\"g\":0.82745099067687988,\"b\":0.50196081399917603,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.31764706969261169,\"g\":0.80392158031463623,\"b\":0.42745098471641541,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.40784314274787903,\"g\":0.82745099067687988,\"b\":0.50196081399917603,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":1.9687635898590088,\"m01\":-489.49108886718750,\"m02\":401.26113891601562,\"m10\":154.218750,\"m11\":6.2488656044006348,\"m12\":75.766197204589844},\"opacity\":0.60000002384185791,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#path-24-outside-1_23833_17138)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.594 156H191.953C191.953 175.028 176.528 190.453 157.5 190.453V192.094V193.734C178.34 193.734 195.234 176.84 195.234 156H193.594ZM157.5 192.094V190.453C138.472 190.453 123.047 175.028 123.047 156H121.406H119.766C119.766 176.84 136.66 193.734 157.5 193.734V192.094ZM121.406 156H123.047C123.047 136.972 138.472 121.547 157.5 121.547V119.906V118.266C136.66 118.266 119.766 135.16 119.766 156H121.406ZM157.5 119.906V121.547C176.528 121.547 191.953 136.972 191.953 156H193.594H195.234C195.234 135.16 178.34 118.266 157.5 118.266V119.906Z",
    fill: "#6CD383",
    fillOpacity: 0.2,
    mask: "url(#path-24-outside-1_23833_17138)"
  })))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M135.188 138.609C148.312 128.765 174.562 132.047 184.406 138.609V133.687C174.562 127.125 148.312 123.844 135.188 133.687V138.609Z",
    fill: "url(#paint2_linear_23833_17138)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M186.319 166.594C176.321 179.602 150.154 183.493 138.909 179.816L140.232 184.557C151.476 188.234 177.643 184.343 187.641 171.335L186.319 166.594Z",
    fill: "url(#paint3_linear_23833_17138)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_23833_17138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.734 157.641L152.578 167.484L172.266 144.516",
    stroke: "url(#paint4_linear_23833_17138)",
    strokeWidth: 6.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23833_17138",
    x: 119.109,
    y: 118.266,
    width: 76.7812,
    height: 76.7812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.65625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.328125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23833_17138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23833_17138",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_23833_17138",
    x: 115.766,
    y: 118.266,
    width: 83.4688,
    height: 102.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23833_17138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23833_17138",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.65625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.328125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_23833_17138"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_angular_23833_17138_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.594 156H191.953C191.953 175.028 176.528 190.453 157.5 190.453V192.094V193.734C178.34 193.734 195.234 176.84 195.234 156H193.594ZM157.5 192.094V190.453C138.472 190.453 123.047 175.028 123.047 156H121.406H119.766C119.766 176.84 136.66 193.734 157.5 193.734V192.094ZM121.406 156H123.047C123.047 136.972 138.472 121.547 157.5 121.547V119.906V118.266C136.66 118.266 119.766 135.16 119.766 156H121.406ZM157.5 119.906V121.547C176.528 121.547 191.953 136.972 191.953 156H193.594H195.234C195.234 135.16 178.34 118.266 157.5 118.266V119.906Z",
    mask: "url(#path-24-outside-1_23833_17138)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_23833_17138",
    x: 137.222,
    y: 141.234,
    width: 40.5563,
    height: 34.2234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.46094
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11563
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23833_17138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23833_17138",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_23833_17138",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2287.03 2141.16) scale(5775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CE08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#35C556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#157A2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23833_17138",
    x1: 135.188,
    y1: 127.475,
    x2: 184.406,
    y2: 127.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23833_17138",
    x1: 206.299,
    y1: 169.776,
    x2: 141.901,
    y2: 190.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23833_17138",
    x1: 142.734,
    y1: 144.516,
    x2: 142.734,
    y2: 167.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23833_17138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white",
    transform: "translate(115.5 114)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessVerifyId);
export default __webpack_public_path__ + "static/media/successVerifyID.324986d617a2263a693a39cde8e97f09.svg";
export { ForwardRef as ReactComponent };